import React, { createContext, useContext } from 'react';

const MarketingInsightsContext = createContext(null);

export const MarketingInsightsProvider = ({ value, children }) => (
  <MarketingInsightsContext.Provider value={value}>
    {children}
  </MarketingInsightsContext.Provider>
);

export const useMarketingInsightsContext = () => {
  const ctx = useContext(MarketingInsightsContext);
  if (!ctx) {
    throw new Error('useMarketingInsightsContext must be used inside MarketingInsightsProvider');
  }
  return ctx;
};

// Soft variant for components (e.g. AudienceInsights) that need to render
// both inside the provider (full app) and standalone (unit tests with stubbed
// props). Returns null when no provider is present.
export const useOptionalMarketingInsightsContext = () =>
  useContext(MarketingInsightsContext);
